import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { ButtonBase, Paper, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/components/Text";

import { type Case } from "../types";

interface Props {
  case: Case;
  onClick?: () => void;
}

export function MobileCaseCard({ case: caseItem, onClick }: Props) {
  const { patient } = caseItem.attributes;

  return (
    <ButtonBase
      onClick={onClick}
      sx={{ width: "100%", textAlign: "left", borderRadius: 2, display: "block" }}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          px: 2.5,
          py: 2,
          bgcolor: "background.paper",
          border: "1px solid",
          borderColor: "transparent",
          boxShadow: "0 1px 4px 0 rgba(0,0,0,0.25)",
          padding: "1rem",
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <Stack flex={1} spacing={0.75}>
            <Text variant="h5" data-dd-privacy="mask">
              {patient.attributes.externalPatientIdentifier}
            </Text>
            <Stack direction="row" alignItems="flex-start" spacing={0.5}>
              <LocationOnIcon
                sx={{ fontSize: 18, mt: 0.2, color: "text.secondary", flexShrink: 0 }}
              />
              <Text variant="body1" data-dd-privacy="mask" sx={{ color: "text.secondary" }}>
                {patient.attributes.formattedAddress}
              </Text>
            </Stack>
          </Stack>
          <ChevronRightIcon sx={{ color: "text.secondary", flexShrink: 0 }} />
        </Stack>
      </Paper>
    </ButtonBase>
  );
}
